var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMethodsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0968 1.18146C23.8489 0.687083 23.3443 0.375 22.7916 0.375H8.20829C7.65558 0.375 7.151 0.687083 6.90308 1.18146L1.06975 12.8481C0.864121 13.2579 0.864121 13.7421 1.06975 14.1533L6.90308 25.82C7.151 26.3129 7.65558 26.625 8.20829 26.625H22.7916C23.3443 26.625 23.8489 26.3129 24.0968 25.8185L29.9302 14.1519C30.1358 13.7421 30.1358 13.2579 29.9302 12.8467L24.0968 1.18146ZM26.2654 12.0417H14.9429L10.5679 3.29167H21.8904L26.2654 12.0417ZM4.00537 13.5L8.20829 5.09417L12.4112 13.5L8.20829 21.9058L4.00537 13.5ZM21.8904 23.7083H10.5679L14.9429 14.9583H26.2654L21.8904 23.7083Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethodsIcon);
export default __webpack_public_path__ + "static/media/MethodsIcon.cfe5f341.svg";
export { ForwardRef as ReactComponent };